'use strict';

/** @type {import('./min')} */
module.exports = Math.min;



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-intrinsics/min.js
// module id = 387
// module chunks = 0